import { render, staticRenderFns } from "./OnboardingAge.vue?vue&type=template&id=72c4b306&"
import script from "./OnboardingAge.vue?vue&type=script&lang=js&"
export * from "./OnboardingAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports